(function () {
  'use strict';

  function initCinema(root) {
    var track = root.querySelector('.cinema__track');
    var screens = Array.prototype.slice.call(root.querySelectorAll('.cinema__screen'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-cinema-dot]'));
    var prevBtn = root.querySelector('[data-cinema-prev]');
    var nextBtn = root.querySelector('[data-cinema-next]');

    if (!track || screens.length === 0) return;

    var currentIndex = 0;
    var isNavigating = false;
    var navTimer = null;

    function setActive(index) {
      currentIndex = index;
      screens.forEach(function (screen, i) {
        screen.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index === screens.length - 1;
    }

    function goTo(index) {
      if (isNavigating) return;
      index = Math.max(0, Math.min(screens.length - 1, index));
      if (index === currentIndex) return;

      isNavigating = true;
      setActive(index);
      screens[index].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });

      window.clearTimeout(navTimer);
      navTimer = window.setTimeout(function () {
        isNavigating = false;
      }, 550);
    }

    var observer = new IntersectionObserver(
      function (entries) {
        // While a button/dot click is driving the scroll, don't let the
        // observer's mid-scroll readings fight with that — only trust it
        // for scroll/swipe navigation the user does by hand.
        if (isNavigating) return;
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            var index = parseInt(entry.target.dataset.cinemaScreen, 10);
            setActive(index);
          }
        });
      },
      { root: track, threshold: [0.6] }
    );

    screens.forEach(function (screen) {
      observer.observe(screen);
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(currentIndex + 1);
      });
    }

    setActive(0);
  }

  function applyColorSettings(root) {
    var overlays = root.querySelectorAll('.cinema__overlay');
    overlays.forEach(function (overlay) {
      if (root.dataset.overlayColor) {
        overlay.style.setProperty('--cinema-overlay-color', root.dataset.overlayColor);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.cinema').forEach(function (root) {
      applyColorSettings(root);
      initCinema(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.cinema');
    if (root) {
      applyColorSettings(root);
      initCinema(root);
    }
  });
})();